import z from "zod";
export const DTOCodeComponentPropUsage = z.object({
    /** How many times this property has been used in this repository? */
    usages: z.number(),
    /** How many times different values have been used with this property? */
    values: z.record(z.number()),
    /** How many times a value has not been specified? (all component usages - usages with values) */
    undefinedValue: z.number(),
});
export const DTOCodeComponentUsage = z.object({
    /**
     * Name of the component in its package.
     * `componentName` and `componentPackageName` uniquely identify a component
     */
    componentName: z.string(),
    /**
     * Which package the component is coming from.
     * `componentName` and `componentPackageName` uniquely identify a component
     */
    componentPackageName: z.string(),
    /** Which repository this component is used in */
    usageRepositoryName: z.string(),
    /** Which package of the repository the component is used in */
    usagePackageName: z.string(),
    /** How many times this component has been used in this repository? */
    usages: z.number(),
    /** How many files has at least one usage of this component? */
    usageFiles: z.number(),
    /** Usage data of the component's props */
    props: z.record(DTOCodeComponentPropUsage),
    /** Timestamp of the scan that has shapshotted this data */
    scanTimestamp: z.string(),
});
export const DTOCodeComponentUsageResponse = z.object({
    componentUsage: DTOCodeComponentUsage.array(),
});
